module.exports = __webpack_public_path__ + "static/media/calendario.4745d56b.svg";